import { ViewerAction, ViewerActionType } from '../_actions/ViewerActions';
import ViewerStore from '../_stores/ViewerStore';

const ViewerReducer = (store:ViewerStore = new ViewerStore(), action: ViewerAction):ViewerStore => {
	switch (action.type) {
		case ViewerActionType.OnViewerResize:
			store = store.withMutations(store => {
				store.set('width', action.width)
				store.set('height', action.height)
			});
			break;

		case ViewerActionType.OnSetIsFullWidth:
			store = store.set('isFullWidth', action.isFullWidth);
			break;
	}
	return store;
}

export default ViewerReducer